import gql from 'graphql-tag'

export const SIGNUP = gql`
  mutation SignUp($name: String!, $email: String!, $password: String!) {
    signup(name: $name, email: $email, password: $password) {
      user {
        id
      }
      token
    }
  }
`

export const LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      user {
        id
        name
        email
        role
      }
      token
    }
  }
`

export const UPDATE_USER_PASSWORD = gql`
  mutation UpdateUserPassword(
    $id: Int!
    $oldPassword: String!
    $newPassword: String!
  ) {
    updateUserPassword(
      id: $id
      oldPassword: $oldPassword
      newPassword: $newPassword
    ) {
      id
      name
    }
  }
`
